// Minimal cart-drawer.js to open and close cart drawer

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('.cart-drawer');
  const openButtons = document.querySelectorAll('[data-cart-open]');
  const closeButtons = document.querySelectorAll('[data-cart-close]');

  if (!cartDrawer) return;

  openButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      cartDrawer.classList.add('is-open');
    });
  });

  closeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      cartDrawer.classList.remove('is-open');
    });
  });
});
